import { render, staticRenderFns } from "./NewsPageCustom.vue?vue&type=template&id=5396ebf1&"
import script from "./NewsPageCustom.vue?vue&type=script&lang=js&"
export * from "./NewsPageCustom.vue?vue&type=script&lang=js&"
import style0 from "./NewsPageCustom.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports